// 人物类型
export const peopleTypes = [
    { value: 0, name: '其他' },
    { value: 1, name: '上市公司董事长' },
    { value: 2, name: '其他公司高管' },
    { value: 3, name: '专家\\学者\\学家\\教授' },
    { value: 4, name: '上市公司董秘' },
    { value: 5, name: '政府人士' },
    { value: 6, name: 'NGO人士' },
    { value: 7, name: '明星' },
    { value: 8, name: '艺术大咖' },
    { value: 9, name: '网红' }
]